import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { FooControlComponent } from "../foo-control/foo-control.component";
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';

import { has, get } from 'lodash';
import { CountryService } from "../../services/country.service";
import { CommonGeneralConfigService, HelperService } from 'common-framework';
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FooMobileNumberComponent),
  multi: true
};


@Component({
  selector: 'foo-mobile-number',
  templateUrl: './foo-mobile-number.component.html',
  styleUrls: ['./foo-mobile-number.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class FooMobileNumberComponent extends FooControlComponent implements OnInit {

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;

  predefinedPreferredCountries: CountryISO[] = [];
  currentCountry: any;
  itemSelectedCountry = null;
  numberWithCountryCode;
  numberWithoutCountryCode;
  filteredCountries = [];
  preferredCountries = [];
  selectedCountry: any

  constructor(
    protected countryService: CountryService,
    protected helperService: HelperService,
    injector: Injector,
    protected generalConfigService: CommonGeneralConfigService
  ) {
    super(injector);
  }


  ngOnInit(): void {
    this.numberWithCountryCode = this.control.value;
    let currentCountry = this.countryService.getCurrentCountry();
    let predefinedPreferredCountries = []
    predefinedPreferredCountries.push(CountryISO[currentCountry]);
    let preferredCountries = this.templateOptions.preferredCountries || predefinedPreferredCountries;
    let selectedCountry = this.generalConfigService.getConfigProperty('commonConfig.defaultCountryCode') || this.templateOptions.selectedCountry || CountryISO[currentCountry];

    if (!this.templateOptions?.filteredCountries || this.templateOptions?.filteredCountries?.excludeCountries) {
      let countries = this.templateOptions.filteredCountries?.countries || [CountryISO.Israel];
      this.filteredCountries = Object.keys(CountryISO)
        .filter((x) => ![...countries].some(y => y == CountryISO[x]))
        .map((x) => CountryISO[x]);
    } else {
      this.filteredCountries = this.templateOptions.filteredCountries?.countries || [];
    }
    this.preferredCountries = preferredCountries?.filter(item => this.filteredCountries?.includes(item));
    if (!this.filteredCountries?.includes(selectedCountry?.toLowerCase())) {
      this.selectedCountry = this.filteredCountries[0];
    } else {
      this.selectedCountry = selectedCountry;
    }

    if (this.control.value) {
      if (!this.control.value.startsWith("+")) {
        this.control.setValue(`+${this.control.value}`);
      }
      const phone = this.helperService.getNumberWithoutCountryCode(this.control.value);
      this.itemSelectedCountry = phone.selectedCountry;
      this.selectedCountry = this.itemSelectedCountry;
      this.control.setValue(phone.phoneWithoutCountryCode);
      this.numberWithoutCountryCode = phone.phoneWithoutCountryCode?.replace(/\s/g, '');
    }
    this.control.markAsPristine();
    this.control.valueChanges.subscribe(newValue => {
      let formattedValue = typeof newValue === 'string' ? newValue.trim() : get(newValue, 'internationalNumber')?.trim();

      if (formattedValue && !formattedValue.startsWith("+")) {
        formattedValue = `+${formattedValue}`;
      }

      const { selectedCountry, phoneWithoutCountryCode } = this.helperService.getNumberWithoutCountryCode(formattedValue);
      const phoneNumberWithoutCode = phoneWithoutCountryCode?.replace(/\s/g, '')?.trim() ?? '';

      if (typeof this.control.value === 'string' && typeof formattedValue === 'string' && formattedValue && selectedCountry) {
        const controlValue = this.control.value;
        if (phoneNumberWithoutCode && phoneNumberWithoutCode !== controlValue && controlValue !== this.numberWithoutCountryCode) {
          this.selectedCountry = selectedCountry;
          this.control.setValue({
            countryCode: selectedCountry,
            number: phoneWithoutCountryCode
          }, { emitEvent: false });
        }
      }

      if (this.numberWithoutCountryCode && phoneNumberWithoutCode && phoneNumberWithoutCode !== this.numberWithoutCountryCode) {
        this.control.markAsTouched();
        this.control.markAsDirty();
      }

      if (newValue === null || phoneNumberWithoutCode === this.numberWithoutCountryCode) {
        this.control.markAsPristine();
      }
    });
  }

  get separateDialCode() {
    if (has(this.templateOptions, 'separateDialCode')) {
      return this.templateOptions.separateDialCode;
    }
    return true;
  }

  preventUnallowedCharacters(event: KeyboardEvent): void {
    const key = event?.key;
    if (key === '+' || key === '-' || key === '(' || key === ')') {
      event.preventDefault();
    }
  }

  removeUnallowedCharactersOnPaste(event: Event): void {
    const input = event?.target as HTMLInputElement;
    if(input?.id === 'phone'){
      input.value = input?.value?.replace(/[^0-9\s]/g, '');
      this.control.setValue(input.value);
    }
  }

}
